import { getData } from ".."
import { DEFAULT_SELECTED_PES_SIDEBAR_MENU, PES_SIDEBAR_MENUS_ENUM } from "../../utils/packagingExecutionUtils"

const defaultNotificationCount = {
	[PES_SIDEBAR_MENUS_ENUM.OUTPUT]: { total: 0 },
	[PES_SIDEBAR_MENUS_ENUM.WEIGHT_CONTROL]: { total: 0, toValidate: 0, done: 0 },
	[PES_SIDEBAR_MENUS_ENUM.TASTING]: { total: 0, toValidate: 0, done: 0 },
	[PES_SIDEBAR_MENUS_ENUM.TO_PACK]: { total: 0, locked: 0, toDo: 0, inProgress: 0, done: 0 },
}
const defaultState = {
	packagingExecutions: [],
	packagingExecution: null,
	packagingExecutionProposedWeights: null,
	filterDate: new Date(),
	filterSite: null,
	filterSites: [],
	selectedSite: null,
	selectedDate: null,
	notificationCounts: defaultNotificationCount,
	selectedSidebar: DEFAULT_SELECTED_PES_SIDEBAR_MENU,
	selectedTab: null,
	snackbar: { open: false, type: "", message: "", duration: 0 }
}

export default function (state = defaultState, action) {
	switch (action.type) {
		case "PACKAGING_EXECUTIONS_FILTERS_LOADED":
			return {
				...state,
				filterDate: action.date,
				filterSite: action.site,
				filterSites: action.sites
			}
		case "PACKAGING_EXECUTION_FILTERS_SELECTED":
			return {
				...state,
				selectedDate: action.selectedDate,
				selectedSite: action.selectedSite
			}
		case "PACKAGING_EXECUTIONS_LOADED":
			return {
				...state,
				packagingExecutions: action.packagingExecutions,
			}
		case "PACKAGING_EXECUTIONS_UDPATED":
			return {
				...state,
				packagingExecutions: state.packagingExecutions.map(packagingExecution => {
					if (packagingExecution.objectId === action.packagingExecution.objectId) {
						return action.packagingExecution
					}
					return packagingExecution
				}),
			}
		case "PACKAGING_EXECUTION_LOADED":
			return {
				...state,
				packagingExecution: action.packagingExecution,
				packagingExecutionProposedWeights: action.packagingExecutionProposedWeights
			}
		case "TOGGLE_PACKAGING_EXECUTION_SNACKBAR":
			return {
				...state,
				snackbar: action.snackbar
			}
		case "LOAD_PES_NOTIFICATIONS_COUNT":
			return {
				...state,
				notificationCounts: action.notificationCounts
			}
		case "CLEAR_PES_NOTIFICATIONS_COUNT":
			return {
				...state,
				notificationCounts: defaultNotificationCount
			}
		case "LOAD_PES_SELECTED_SIDEBAR":
			return {
				...state,
				selectedSidebar: action.selectedSidebar,
				selectedTab: null, // reset tab when switching menu
			}
		case "CLEAR_PES_SELECTED_SIDEBAR":
			return {
				...state,
				selectedSidebar: DEFAULT_SELECTED_PES_SIDEBAR_MENU,
				selectedTab: null,
			}
		case "LOAD_PES_SELECTED_TAB":
			return {
				...state,
				selectedTab: action.selectedTab,
			}
		default:
			return {
				...state
			}
	}
}


//------------------------------------------------------------------//
//--------------------------- Selectors ----------------------------//
//------------------------------------------------------------------//
export const getPackagingExecutionSelector = (state, errorIfNotFound = false) => {
	return getData(state, "packagingExecution.packagingExecution", errorIfNotFound && "No packaging execution selected")
}

export const getPackagingExecutionsSelector = (state, errorIfNotFound = false) => {
	return getData(state, "packagingExecution.packagingExecutions", errorIfNotFound && "No packaging executions found")
}

export const getPackagingExecutionFilterDateSelector = (state, errorIfNotFound = false) => {
	return getData(state, "packagingExecution.filterDate", errorIfNotFound && "No date found")
}

export const getPackagingExecutionFilterSiteSelector = (state, errorIfNotFound = false) => {
	return getData(state, "packagingExecution.filterSite", errorIfNotFound && "No site found")
}

export const getPackagingExecutionSitesSelector = (state, errorIfNotFound = false) => {
	return getData(state, "packagingExecution.filterSites", errorIfNotFound && "No sites found")
}

export const getPackagingExecutionSnackbarSelector = (state, errorIfNotFound = false) => {
	return getData(state, "packagingExecution.snackbar", errorIfNotFound && "No snackbar found")
}

export const getPackagingExecutionSiteSelector = (state, errorIfNotFound = false) => {
	return getData(state, "packagingExecution.selectedSite", errorIfNotFound && "No selected site found")
}

export const getPackagingExecutionDateSelector = (state, errorIfNotFound = false) => {
	return getData(state, "packagingExecution.selectedDate", errorIfNotFound && "No selected date found")
}

export const getPackagingExecutionProposedWeightsSelector = (state, errorIfNotFound = false) => {
	return getData(state, "packagingExecution.packagingExecutionProposedWeights", errorIfNotFound && "No proposed weight found")
}

export const getPEsSidebarNotificationCountsSelector = (state) => {
	return state.packagingExecution.notificationCounts
}

export const getSelectedPEsSidebarMenuSelector = (state) => {
	return state.packagingExecution.selectedSidebar
}

export const getSelectedPEsSidebarTabSelector = (state) => {
	return state.packagingExecution.selectedTab
}